import ApiEndpointConstants from '../constants/api/ApiEndpointConstants';
import CookieUtil from '../utils/CookieUtil';
import api from './API';

export const submitDriveOrder = (data) => {
    const tgid = CookieUtil.loadTelegramId();
    const amount = CookieUtil.loadPaymentAmount() || 6.9;
    const amount_fast = CookieUtil.loadPaymentAmountFast() || 6.9;
    const newData = Object.assign({}, data, {tgid, amount, amount_fast});
    return api.post(
        `${ApiEndpointConstants.ORDER}`,
        { data: JSON.stringify(newData) },
    );
}

export const updateDriveOrder = (data, saveToFile = false) => {
    const tgid = CookieUtil.loadTelegramId();
    const newData = Object.assign({}, data, {tgid});
    let params = { data: JSON.stringify(newData) };
    if (saveToFile) {
        params['saveToFile'] = saveToFile;
    }
    return api.post(
        `${ApiEndpointConstants.ORDER_UPDATE}`,
        params,
    );
}

export const updateOrderStatus = (params) => {
    return api.post(
        `${ApiEndpointConstants.ORDER_STATUS_UPDATE}`,
        params,
    );
}


export const getOrderDetailByOrderNo = (orderNo) => {
    return api.post(
        `${ApiEndpointConstants.ORDER_DETAIL}`,
        {orderNo},
    );
}
